import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { MatDialog } from '@angular/material/dialog';
import { ForgotPasswordDialogComponent } from './forgot-password-dialog/forgot-password-dialog.component';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    hide = true;
    errorMessage: string = '';

    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private router: Router,
        private dialog: MatDialog
    ) {
        this.loginForm = this.fb.group({
            username: ['', [Validators.required]],
            password: ['', [Validators.required]]
        });
    }

    ngOnInit(): void {
        if (this.authService.getCurrentUserValue()) {
            this.router.navigate(['/reports']);
        }
    }

    onSubmit(): void {
        if (this.loginForm.invalid) {
            return;
        }

        const { username, password } = this.loginForm.value;

        this.authService.login(username, password).subscribe({
            next: () => {
                this.router.navigate(['/reports']);
            },
            error: (err) => {
                console.error('Login failed', err);
                this.errorMessage = 'ユーザー名またはパスワードが間違っています';
            }
        });
    }

    openForgotPasswordDialog(): void {
        this.dialog.open(ForgotPasswordDialogComponent, {
            width: '400px'
        });
    }
}